import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import StaffUsers from './pages/StaffUsers';
import Users from './pages/Users';
import Invitations from './pages/Invitations';
import Reports from './pages/Reports';
import SearchHistory from './pages/SearchHistory';
import RidesMonitor from './pages/RidesMonitor';
import Activity from './pages/Activity';
import ChangePassword from './pages/ChangePassword';
import StatisticsOverview from './pages/statistics/Overview';
import StatisticsMarketplace from './pages/statistics/Marketplace';
import StatisticsRideCaptures from './pages/statistics/RideCaptures';
import StatisticsGrowth from './pages/statistics/Growth';
import StatisticsTrustSafety from './pages/statistics/TrustSafety';
import StatisticsDrilldown from './pages/statistics/Drilldown';
import NotFound from './pages/NotFound';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/staff-users"
            element={
              <ProtectedRoute>
                <Layout>
                  <StaffUsers />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Layout>
                  <Users />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/rides"
            element={
              <ProtectedRoute>
                <Layout>
                  <RidesMonitor />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/search-history"
            element={
              <ProtectedRoute>
                <Layout>
                  <SearchHistory />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/invitations"
            element={
              <ProtectedRoute>
                <Layout>
                  <Invitations />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/activity"
            element={
              <ProtectedRoute>
                <Layout>
                  <Activity />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Layout>
                  <Reports />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Statistics (admin reporting) */}
          <Route
            path="/statistics/overview"
            element={
              <ProtectedRoute>
                <Layout>
                  <StatisticsOverview />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statistics/marketplace"
            element={
              <ProtectedRoute>
                <Layout>
                  <StatisticsMarketplace />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statistics/captures"
            element={
              <ProtectedRoute>
                <Layout>
                  <StatisticsRideCaptures />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statistics/growth"
            element={
              <ProtectedRoute>
                <Layout>
                  <StatisticsGrowth />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statistics/trust"
            element={
              <ProtectedRoute>
                <Layout>
                  <StatisticsTrustSafety />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statistics/drilldown/:metric"
            element={
              <ProtectedRoute>
                <Layout>
                  <StatisticsDrilldown />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <Layout>
                  <ChangePassword />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* Catch-all route for 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
